$(document).ready(function(){
  // -- gallery --
  var sliderGallery = $('.slider__gallery');
  var sliderGallerySettings = {
    arrows: true,
    dots: false,
    infinite: false,
  };
  sliderGallery.slick(sliderGallerySettings);

  // -- home banner --
  var sliderBannerHome = $('.slider__bannerHome');
  var sliderBannerHomeSettings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000-800,
    cssEase: 'ease-in-out',
    pauseOnHover: false,
    fade: true,
    speed: 800,
    arrows: false,
    dots: false,
  };
  sliderBannerHome.slick(sliderBannerHomeSettings);

  // -- home sp --
  var sliderSP = $('.slider__sp');
  var sliderSPSettings = {
    arrows: true,
    dots: false,
    slidesToShow: 4,
    infinite: false,
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      }
    },{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
      }
    }]
  };
  sliderSP.slick(sliderSPSettings);

  // -- home rn --
  var sliderRN = $('.slider__rn');
  var sliderRNSettings = {
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    responsive: [{
      breakpoint: 768,
      settings: 'unslick'
    }]
  };
  sliderRN.slick(sliderRNSettings);

});